import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as moment from "moment";
// bao migrate - module not found: import Finito from "modules/finito-module";
import TabPage from "./../factories/tab-page";
import baoRouter from "./../services/bao-router";
import BaoMenu from "./../services/bao-menu";
import StartModule from "./start-module";
import FinitoService from "./../services/finito-service";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
function StartViewModel(tabPage, meinString) {
    var self = this;
    StartModule.call(self, tabPage);
    var emptyGuid = "00000000-0000-0000-0000-000000000000";
    self.Bao = Bao;
    self.TabPage = tabPage;
    self.ValidDateJs = ko.observable(moment().format(Bao.Utils.DateTimeFormat));
    self.Shiftbooks = ko.observableArray();
    self.ShiftbookId = ko.observable();
    self.InputDateTimePicker = ko.observable();
    self.Ready = ko.observable(false);
    self.ValidDateJs.subscribe(function (validDateJs) {
        if (validDateJs == null) {
            setTimeout(function () {
                var dateTimePicker = $(self.InputDateTimePicker()).parent().data("DateTimePicker");
                dateTimePicker.date(moment());
            }, 0);
        }
        else {
            self.TabPage.IsLoading(true);
            $.when(self.getNavigation(validDateJs), self.RefreshStart()).then(function () {
                self.TabPage.IsLoading(false);
            });
        }
    });
    self.ShiftbookId.subscribe(function () {
        if (self.ShiftbookId()) {
            self.TabPage.IsLoading(true);
            return Bao.post("Report/GetReportIdByShiftbookAndCurrentDate", JSON.stringify({
                shiftbookId: self.ShiftbookId(),
                validDateJs: self.ValidDateJs()
            })).then(function (reportId) {
                if (reportId != null && reportId != emptyGuid && self.Ready()) {
                    baoRouter.setHash("report/" + reportId);
                    self.ShiftbookId(null);
                }
            }).always(function () {
                self.TabPage.IsLoading(false);
            });
        }
    });
    self.getNavigation = function (validDate) {
        return Bao.post("Start/GetShiftbooks", JSON.stringify({
            validDateJs: validDate
        })).then(function (result) {
            self.Shiftbooks(result);
        });
    };
    var baseInit = self.init;
    self.init = function () {
        return $.when(self.getNavigation(self.ValidDateJs()), baseInit.call(self));
    };
    self.loaded = function () {
        var def = $.Deferred();
        var title = Bao.Session.GetMessage("msgDashboard");
        tabPage.Title(title());
        title.subscribe(function (value) {
            self.TabPage.Title(title());
        });
        self.registerMenuClick();
        tabPage.IsLoading(false);
        def.resolve();
        self.ShiftbookId(null);
        self.Ready(true);
        FinitoService.DashBoardDate = self.ValidDateJs;
        return def.promise();
    };
}
Bao.inherit(StartViewModel, StartModule);
StartViewModel.prototype.registerMenuClick = function () {
    var self = this;
    BaoMenu.registerEvent(function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            switch (btn.ActionKey()) {
                case "DashboardToday":
                    self.showToday();
                    break;
                case "RefreshDashboard":
                    self.TabPage.IsLoading(true);
                    self.RefreshStart().then(function () {
                        self.TabPage.IsLoading(false);
                    });
                    break;
            }
        }
    });
};
StartViewModel.prototype.showToday = function () {
    var dateTimePicker = $(this.InputDateTimePicker()).parent().first().data("DateTimePicker");
    dateTimePicker.date(moment());
};
export default StartViewModel;